// extracted by mini-css-extract-plugin
export default {"titlePage":"roleOrg_titlePage__rCp7i"};